export default "__VITE_ASSET__CHhclsaP__"